import Link from "@/components/ui/RouterLink";
import { ArrowRight, MessageSquare } from "lucide-react";
import { SectionEyebrow } from "@/components/ui/SectionEyebrow";
import { brand } from "@/config/brand";
import { InfrastructureVisual } from "./InfrastructureVisual";

export function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="grid-backdrop absolute inset-0 opacity-40" aria-hidden="true" />
      <div
        className="absolute -top-40 left-1/4 h-[520px] w-[520px] rounded-full bg-primary/25 blur-[140px]"
        aria-hidden="true"
      />
      <div
        className="absolute top-10 right-0 h-[420px] w-[420px] rounded-full bg-cyan/20 blur-[120px]"
        aria-hidden="true"
      />

      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 py-20 lg:grid-cols-2 lg:px-8 lg:py-28">
        <div>
          <SectionEyebrow>Cloud, Server &amp; Network Infrastructure</SectionEyebrow>
          <h1 className="mt-5 font-display text-4xl font-semibold leading-[1.08] tracking-tight text-text-primary sm:text-5xl lg:text-[3.4rem]">
            Infrastructure Built to <span className="text-gradient">Perform</span>. Designed to{" "}
            <span className="text-gradient">Scale</span>.
          </h1>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-text-secondary">
            Deploy reliable virtual servers, dedicated infrastructure, business email and cloud
            solutions built around the performance, control and security your business needs.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              href="/#products"
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-full bg-gradient-brand px-6 py-3.5 text-sm font-medium text-white transition hover:brightness-110"
            >
              Explore Our Products <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              href="/contact"
              className="focus-ring inline-flex items-center justify-center gap-2 rounded-full border border-border px-6 py-3.5 text-sm font-medium text-text-primary transition hover:border-cyan/50"
            >
              <MessageSquare className="h-4 w-4" /> Talk to an Infrastructure Expert
            </Link>
          </div>

          <p className="mt-8 text-xs text-text-muted">{brand.trustLine}</p>
        </div>

        <InfrastructureVisual />
      </div>
    </section>
  );
}
